import React, { useEffect, useState } from "react";
import "./index.css";
import redirect from "../../../assets/media/icon/subdirectory_arrow_right.svg";
import loader from "../../../assets/media/loader/dual-ring.svg";
import ClicksLineChart from "./Sub/ClicksLineChart";
import { formatDate } from "../../../utils/formatDate";
import axios from "../../../api/axios";
import useAuth from "../../../hooks/useAuth";
import ConfirmDelete from "./Sub/ConfirmDelete";
import ConfirmToggleStatus from "./Sub/ConfirmToggleStatus";
import ConfirmEdit from "./Sub/ConfirmEdit";
const U_URL = "/link/update";
const D_URL = "/link/delete";
const C_URL = "/click/getlinechartclicks";
const LinkInfo = ({
  link,
  setGetLinksIfDataUpdates,
  getLinksIfDataUpdates,
}) => {
  const { auth } = useAuth();
  const [isCopied, setIsCopied] = useState(false);
  const [confirmingDelete, setConfirmingDelete] = useState(false);
  const [confirmingToggleStatus, setConfirmingToggleStatus] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [toggling, setToggling] = useState(false);
  const [last24hClicks, setLast24hClicks] = useState(0);
  const [lastWeekClicks, setLastWeekClicks] = useState(0);
  const [changes24h, setChanges24h] = useState(0);
  const [changes7d, setChanges7d] = useState(0);
  const [updatingClickData, setUpdatingClickData] = useState(false);
  const [confirmingEdit, setConfirmingEdit] = useState(false);
  const [editing, setEditing] = useState(false);
  const [data, setData] = useState({
    labels: ["-", "-", "-", "-", "-", "-", "-"],
    datasets: [
      {
        label: " Clicks",
        data: [0, 0, 0, 0, 0, 0, 0],
        borderColor: "#766aff",
        borderWidth: 1.3,
        pointBorderColor: "transparent",
        pointBackgroundColor: "transparent",
        padding: 0,
        // tension: 0.3,
        fill: true,
        backgroundColor: (context) => {
          const ctx = context.chart.ctx;
          const gradient = ctx.createLinearGradient(0, 0, 0, 200);
          gradient.addColorStop(0, "rgba(196,178,255,0.9)");
          gradient.addColorStop(1, "rgba(255,255,255,0)");
          return gradient;
        },
      },
    ],
  });
  const handleCopyClick = () => {
    navigator.clipboard
      .writeText("snil.ink/" + link.shorten)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 500);
      })
      .catch((error) => {});
  };
  const toggleStatus = async () => {
    setToggling(true);
    const newStatus = link.status === "active" ? "disable" : "active";
    try {
      const response = await axios.put(
        U_URL,
        JSON.stringify({
          id: link._id,
          status: newStatus,
        }),
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
      setToggling(false);
      setConfirmingToggleStatus(false);
      setGetLinksIfDataUpdates(!getLinksIfDataUpdates);
    } catch (err) {}
    setToggling(false);
    setGetLinksIfDataUpdates(!getLinksIfDataUpdates);
  };
  const deleteLink = async () => {
    setDeleting(true);
    try {
      const response = await axios.delete(D_URL, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
        params: {
          id: link._id,
          userId: auth.userId,
        },
      });
      setDeleting(false);
      setConfirmingDelete(false);
      setGetLinksIfDataUpdates(!getLinksIfDataUpdates);
      // window.location.reload();
    } catch (error) {}
    setDeleting(false);
    setConfirmingDelete(false);
    // window.location.reload();
  };
  const handleEdit = async () => {
    setConfirmingEdit(true);
  };
  const editLink = async (newTitle) => {
    setEditing(true);
    try {
      const response = await axios.put(
        U_URL,
        JSON.stringify({
          id: link._id,
          title: newTitle,
        }),
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      setEditing(false);
      setConfirmingEdit(false);
      setGetLinksIfDataUpdates(!getLinksIfDataUpdates);
    } catch (err) {}
    setEditing(false);
    setConfirmingEdit(false);
    setGetLinksIfDataUpdates(!getLinksIfDataUpdates);
  };
  const handleDelete = async () => {
    setConfirmingDelete(true);
  };
  const handleToggleStatus = async () => {
    setConfirmingToggleStatus(true);
  };
  const getLinksClicksInfo = async () => {
    try {
      setUpdatingClickData(true);
      const response = await axios.get(C_URL, {
        params: { userId: auth.userId, linkId: link.shorten },
        withCredentials: true,
        headers: { "Content-Type": "application/json" },
      });
      setLast24hClicks(response.data.lastDay || 0);
      setLastWeekClicks(response.data.lastWeek || 0);
      setChanges24h(response.data.last24hChanges || 0);
      setChanges7d(response.data.lastWeekChanges || 0);
      setUpdatingClickData(false);
      setData(
        response.data.chartData
          ? {
              labels: response.data.chartData.map((entry) => entry.date),
              datasets: [
                {
                  data: response.data.chartData.map((entry) => entry.clicks),
                  label: "Clicks",
                  borderColor: "#766aff",
                  borderWidth: 1.3,
                  pointBorderColor: "transparent",
                  pointBackgroundColor: "transparent",
                  padding: 0,
                  // tension: 0.3,
                  fill: true,
                  backgroundColor: (context) => {
                    const ctx = context.chart.ctx;
                    const gradient = ctx.createLinearGradient(0, 0, 0, 200);
                    gradient.addColorStop(0, "rgba(196,178,255,0.9)");
                    gradient.addColorStop(1, "rgba(255,255,255,0)");
                    return gradient;
                  },
                },
              ],
            }
          : {
              labels: ["-", "-", "-", "-", "-", "-", "-"],
              datasets: [
                {
                  label: " Clicks",
                  data: [0, 0, 0, 0, 0, 0, 0],
                  borderColor: "#766aff",
                  borderWidth: 1.3,
                  pointBorderColor: "transparent",
                  pointBackgroundColor: "transparent",
                  padding: 0,
                  // tension: 0.3,
                  fill: true,
                  backgroundColor: (context) => {
                    const ctx = context.chart.ctx;
                    const gradient = ctx.createLinearGradient(0, 0, 0, 200);
                    gradient.addColorStop(0, "rgba(196,178,255,0.9)");
                    gradient.addColorStop(1, "rgba(255,255,255,0)");
                    return gradient;
                  },
                },
              ],
            }
      );
    } catch (err) {}
    setUpdatingClickData(false);
  };
  useEffect(() => {
    getLinksClicksInfo();
  }, [link.shorten]);
  return (
    <div className="link-info | mb-20px">
      {confirmingEdit && (
        <ConfirmEdit
          short={link.shorten}
          title={link.title}
          original={link.original}
          editLink={editLink}
          editing={editing}
          setConfirmingEdit={setConfirmingEdit}
        />
      )}
      {confirmingDelete && (
        <ConfirmDelete
          id={link.shorten}
          setConfirmingDelete={setConfirmingDelete}
          deleteLink={deleteLink}
          deleting={deleting}
        />
      )}
      {confirmingToggleStatus && (
        <ConfirmToggleStatus
          id={link.shorten}
          status={link.status}
          setConfirmingToggle={setConfirmingToggleStatus}
          toggleStatus={toggleStatus}
          toggling={toggling}
        />
      )}
      <div className="md:p-20px p-16px rounded-lg bg-white dark:bg-accent-800 flex justify-between sm:gap-48px gap-32px md:flex-row sm:flex-col flex-col">
        <div className="flex gap-32px">
          <div className="flex flex-col justify-between gap-20px">
            <div className="flex flex-col gap-10px ">
              <div className="md:text-xl text-lg text-primary-900 dark:text-accent-100 font-semibold">
                {link?.title}
              </div>
              <div className="flex gap-10px items-center">
                <a
                  href={link?.shorten}
                  className="text-primary-500 font-medium text-lg"
                  target="_blank"
                >
                  snil.ink/{link?.shorten}
                </a>
                <button
                  className="flex p-[6px] bg-white dark:bg-accent-700 outline-none border-none cursor-pointer rounded-lg duration-300 hover:bg-primary-50 "
                  onClick={handleCopyClick}
                >
                  {isCopied ? (
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_311_611"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width=""
                        height="24"
                      >
                        <rect width="24" height="24" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_311_611)">
                        <path
                          d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97501L20.1501 7.40001L9.5501 18Z"
                          fill="#ADAFBF"
                        />
                      </g>
                    </svg>
                  ) : (
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_252_12427"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="24"
                        height="24"
                      >
                        <rect width="24" height="24" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_252_12427)">
                        <path
                          d="M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6H5V20H16V22H5ZM9 18C8.45 18 7.97917 17.8042 7.5875 17.4125C7.19583 17.0208 7 16.55 7 16V4C7 3.45 7.19583 2.97917 7.5875 2.5875C7.97917 2.19583 8.45 2 9 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V16C20 16.55 19.8042 17.0208 19.4125 17.4125C19.0208 17.8042 18.55 18 18 18H9ZM9 16H18V4H9V16Z"
                          fill="#ADAFBF"
                        />
                      </g>
                    </svg>
                  )}
                </button>
              </div>
              <a
                href={link?.original}
                className="text-accent-300 flex items-center gap-10px"
                target="_blank"
              >
                <img src={redirect} alt="" />
                <p className="overflow-hidden whitespace-nowrap max-w-[200px] w-fit text-ellipsis ">
                  {link?.original}
                </p>
              </a>
              <div className="text-sm text-accent-200">
                {formatDate(link?.dateCreated)}
              </div>
            </div>
            <div className="flex gap-10px ">
              <button
                className="flex p-[6px] bg-white dark:bg-accent-700 outline-none border-none cursor-pointer rounded-lg duration-300 hover:bg-primary-50 "
                onClick={() => handleEdit()}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_466_618"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  >
                    <rect width="24" height="24" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_466_618)">
                    <path
                      d="M5 19H6.4L15.025 10.375L13.625 8.975L5 17.6V19ZM19.3 8.925L15.05 4.725L16.45 3.325C16.8333 2.94167 17.3042 2.75 17.8625 2.75C18.4208 2.75 18.8917 2.94167 19.275 3.325L20.675 4.725C21.0583 5.10833 21.2583 5.57083 21.275 6.1125C21.2917 6.65417 21.1083 7.11667 20.725 7.5L19.3 8.925ZM17.85 10.4L7.25 21H3V16.75L13.6 6.15L17.85 10.4Z"
                      fill="#ADAFBF"
                    />
                  </g>
                </svg>
              </button>
              <button
                className="flex p-[6px] bg-white dark:bg-accent-700 outline-none border-none cursor-pointer rounded-lg duration-300 hover:bg-primary-50 "
                onClick={() => handleToggleStatus()}
              >
                {link?.status === "active" ? (
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_200_12410"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="24"
                      height="24"
                    >
                      <rect width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_200_12410)">
                      <path
                        d="M19.6737 20.9368L17.1895 18.4526C16.5158 18.9018 15.7895 19.2456 15.0105 19.4842C14.2316 19.7228 13.407 19.8421 12.5368 19.8421C11.3719 19.8421 10.2772 19.6211 9.25263 19.1789C8.22807 18.7368 7.33684 18.1368 6.57895 17.3789C5.82105 16.6211 5.22105 15.7298 4.77895 14.7053C4.33684 13.6807 4.11579 12.586 4.11579 11.4211C4.11579 10.5509 4.23509 9.72632 4.47368 8.94737C4.71228 8.16842 5.05614 7.44211 5.50526 6.76842L3 4.26316L4.2 3.06316L20.8737 19.7368L19.6737 20.9368ZM11.6947 18.1158V16.4737C11.2316 16.4737 10.8351 16.3088 10.5053 15.9789C10.1754 15.6491 10.0105 15.2526 10.0105 14.7895V13.9474L5.96842 9.90526C5.92632 10.1579 5.88772 10.4105 5.85263 10.6632C5.81754 10.9158 5.8 11.1684 5.8 11.4211C5.8 13.1193 6.35789 14.607 7.47368 15.8842C8.58947 17.1614 9.99649 17.9053 11.6947 18.1158ZM19.5684 16.0316L18.3474 14.8105C18.6421 14.2912 18.8702 13.7474 19.0316 13.1789C19.193 12.6105 19.2737 12.0246 19.2737 11.4211C19.2737 10.0456 18.8912 8.78947 18.1263 7.65263C17.3614 6.51579 16.3404 5.69474 15.0632 5.18947V5.52632C15.0632 5.98947 14.8982 6.38597 14.5684 6.71579C14.2386 7.04561 13.8421 7.21053 13.3789 7.21053H11.6947V8.1579L7.92632 4.38947C8.6 3.95439 9.32281 3.61404 10.0947 3.36842C10.8667 3.12281 11.6807 3 12.5368 3C13.7018 3 14.7965 3.22105 15.8211 3.66316C16.8456 4.10526 17.7368 4.70526 18.4947 5.46316C19.2526 6.22105 19.8526 7.11228 20.2947 8.13684C20.7368 9.1614 20.9579 10.2561 20.9579 11.4211C20.9579 12.2772 20.8351 13.0912 20.5895 13.8632C20.3439 14.6351 20.0035 15.3579 19.5684 16.0316Z"
                        fill="#ADAFBF"
                      />
                    </g>
                  </svg>
                ) : (
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_404_2340"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="24"
                      height="24"
                    >
                      <rect width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_404_2340)">
                      <path
                        d="M10.5 19.25C9.28958 19.25 8.15208 19.0203 7.0875 18.5609C6.02292 18.1016 5.09687 17.4781 4.30937 16.6906C3.52187 15.9031 2.89844 14.9771 2.43906 13.9125C1.97969 12.8479 1.75 11.7104 1.75 10.5C1.75 9.28958 1.97969 8.15208 2.43906 7.0875C2.89844 6.02292 3.52187 5.09687 4.30937 4.30937C5.09687 3.52187 6.02292 2.89844 7.0875 2.43906C8.15208 1.97969 9.28958 1.75 10.5 1.75C11.7104 1.75 12.8479 1.97969 13.9125 2.43906C14.9771 2.89844 15.9031 3.52187 16.6906 4.30937C17.4781 5.09687 18.1016 6.02292 18.5609 7.0875C19.0203 8.15208 19.25 9.28958 19.25 10.5C19.25 11.7104 19.0203 12.8479 18.5609 13.9125C18.1016 14.9771 17.4781 15.9031 16.6906 16.6906C15.9031 17.4781 14.9771 18.1016 13.9125 18.5609C12.8479 19.0203 11.7104 19.25 10.5 19.25ZM9.625 17.4563V15.75C9.14375 15.75 8.73177 15.5786 8.38906 15.2359C8.04635 14.8932 7.875 14.4813 7.875 14V13.125L3.675 8.925C3.63125 9.1875 3.59115 9.45 3.55469 9.7125C3.51823 9.975 3.5 10.2375 3.5 10.5C3.5 12.2646 4.07969 13.8104 5.23906 15.1375C6.39844 16.4646 7.86042 17.2375 9.625 17.4563ZM15.6625 15.225C15.9542 14.9042 16.2167 14.5578 16.45 14.1859C16.6833 13.8141 16.8766 13.4276 17.0297 13.0266C17.1828 12.6255 17.2995 12.2135 17.3797 11.7906C17.4599 11.3677 17.5 10.9375 17.5 10.5C17.5 9.07083 17.1026 7.76563 16.3078 6.58438C15.513 5.40313 14.4521 4.55 13.125 4.025V4.375C13.125 4.85625 12.9536 5.26823 12.6109 5.61094C12.2682 5.95365 11.8563 6.125 11.375 6.125H9.625V7.875C9.625 8.12292 9.54115 8.33073 9.37344 8.49844C9.20573 8.66615 8.99792 8.75 8.75 8.75H7V10.5H12.25C12.4979 10.5 12.7057 10.5839 12.8734 10.7516C13.0411 10.9193 13.125 11.1271 13.125 11.375V14H14C14.3792 14 14.7219 14.113 15.0281 14.3391C15.3344 14.5651 15.5458 14.8604 15.6625 15.225Z"
                        fill="#ADAFBF"
                      />
                    </g>
                  </svg>
                )}
              </button>
              <button
                className="flex p-[6px] bg-white dark:bg-accent-700 outline-none border-none cursor-pointer rounded-lg duration-300 hover:bg-primary-50 "
                onClick={() => handleDelete()}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_200_12404"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  >
                    <rect width="24" height="24" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_200_12404)">
                    <path
                      d="M7.52632 19.1579C7.06316 19.1579 6.66667 18.993 6.33684 18.6632C6.00702 18.3333 5.84211 17.9368 5.84211 17.4737V6.52632H5V4.84211H9.21053V4H14.2632V4.84211H18.4737V6.52632H17.6316V17.4737C17.6316 17.9368 17.4667 18.3333 17.1368 18.6632C16.807 18.993 16.4105 19.1579 15.9474 19.1579H7.52632ZM15.9474 6.52632H7.52632V17.4737H15.9474V6.52632ZM9.21053 15.7895H10.8947V8.21053H9.21053V15.7895ZM12.5789 15.7895H14.2632V8.21053H12.5789V15.7895Z"
                      fill="#ADAFBF"
                    />
                  </g>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div className="flex md:flex-col sm:flex-row flex-col gap-16px items-center sm:w-auto w-full">
          <ClicksLineChart
            updatingClickData={updatingClickData}
            data={data}
            clicks={link.clicks}
          />
          <div className="flex justify-between gap-16px md:flex-row sm:flex-col flex-row w-full">
            <div className="bg-white dark:bg-accent-700 dark:border-none w-full py-2 md:px-16px px-12px relative overflow-hidden flex items-center rounded-lg shadow-sm md:gap-20px gap-16px border border-primary-50">
              {updatingClickData && (
                <div className="absolute bg-[rgba(255, 255, 255, 0.5)] backdrop-blur-sm z-[999] top-0 bottom-0 right-0 left-0 flex justify-center items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="32px"
                    height="32px"
                    viewBox="0 0 100 100"
                    preserveAspectRatio="xMidYMid"
                  >
                    <circle
                      cx="50"
                      cy="50"
                      r="32"
                      strokeWidth="8"
                      stroke="#9188ff"
                      strokeDasharray="50.26548245743669 50.26548245743669"
                      fill="none"
                      strokeLinecap="round"
                    >
                      <animateTransform
                        attributeName="transform"
                        type="rotate"
                        repeatCount="indefinite"
                        dur="1s"
                        keyTimes="0;1"
                        values="0 50 50;360 50 50"
                      ></animateTransform>
                    </circle>
                  </svg>
                </div>
              )}
              <div className="text-primary-400 dark:text-primary-200 md:text-xl sm:text-lg text-base font-medium ">
                {lastWeekClicks}
              </div>
              <div className={`label-changes`}>
                <label className="text-xs font-medium text-accent-300 dark:text-accent-200">
                  Last week
                </label>
                <div
                  className={`text-10px font-semibold flex items-center gap-1 ${
                    changes7d <= 0
                      ? "text-[#ff3737] dark:text-[#ff6969]"
                      : "text-[#039855]"
                  }`}
                >
                  {changes7d <= 0 ? (
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_235_13368"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="14"
                        height="14"
                      >
                        <rect width="14" height="14" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_235_13368)">
                        <path
                          d="M9.33317 10.5V9.33333H10.8498L7.8165 6.32917L5.48317 8.6625L1.1665 4.31667L1.98317 3.5L5.48317 7L7.8165 4.66667L11.6665 8.51667V7H12.8332V10.5H9.33317Z"
                          className="fill-[#ff3737] dark:fill-[#ff6969]"
                        />
                      </g>
                    </svg>
                  ) : (
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_458_171"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="14"
                        height="14"
                      >
                        <rect width="14" height="14" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_458_171)">
                        <path
                          d="M1.98341 10.5L1.16675 9.68333L5.48342 5.3375L7.81675 7.67083L10.8501 4.66667H9.33342V3.5H12.8334V7H11.6667V5.48333L7.81675 9.33333L5.48342 7L1.98341 10.5Z"
                          fill="#039855"
                        />
                      </g>
                    </svg>
                  )}
                  {changes7d <= 0 ? "-" : "+"}
                  {Math.abs(changes7d).toFixed(1)}%
                </div>
              </div>
            </div>
            <div className="bg-white dark:bg-accent-700 dark:border-none w-full py-2 md:px-16px px-12px relative overflow-hidden flex items-center rounded-lg shadow-sm md:gap-20px gap-16px border border-primary-50">
              {updatingClickData && (
                <div className="absolute bg-[rgba(255, 255, 255, 0.5)] backdrop-blur-sm z-[999] top-0 bottom-0 right-0 left-0 flex justify-center items-center ">
                  <img className="w-[34px]" src={loader} alt="" />
                </div>
              )}
              <div className="text-primary-400 dark:text-primary-200 md:text-xl sm:text-lg text-base font-medium ">
                {last24hClicks}
              </div>
              <div className={`label-changes`}>
                <label className="text-xs font-medium text-accent-300 dark:text-accent-200">
                  Last 24h
                </label>
                <div
                  className={`text-10px font-semibold flex items-center gap-1  ${
                    changes24h <= 0
                      ? "text-[#ff3737] dark:text-[#ff6969]"
                      : "text-[#039855]"
                  }`}
                >
                  {changes7d <= 0 ? (
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_235_13368"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="14"
                        height="14"
                      >
                        <rect width="14" height="14" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_235_13368)">
                        <path
                          d="M9.33317 10.5V9.33333H10.8498L7.8165 6.32917L5.48317 8.6625L1.1665 4.31667L1.98317 3.5L5.48317 7L7.8165 4.66667L11.6665 8.51667V7H12.8332V10.5H9.33317Z"
                          className="fill-[#ff3737] dark:fill-[#ff6969]"
                        />
                      </g>
                    </svg>
                  ) : (
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_458_171"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="14"
                        height="14"
                      >
                        <rect width="14" height="14" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_458_171)">
                        <path
                          d="M1.98341 10.5L1.16675 9.68333L5.48342 5.3375L7.81675 7.67083L10.8501 4.66667H9.33342V3.5H12.8334V7H11.6667V5.48333L7.81675 9.33333L5.48342 7L1.98341 10.5Z"
                          fill="#039855"
                        />
                      </g>
                    </svg>
                  )}
                  {changes24h <= 0 ? "-" : "+"}
                  {Math.abs(changes24h).toFixed(1)}%
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LinkInfo;
